import { Analytics } from "@vercel/analytics/react";
import Home from "./pages/Home";

function App() {
  return (
    <div>
      <Analytics />
      <Home />
    </div>
  );
}

export default App;
